import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ResourceName_Account_Fragment = { __typename?: 'Account', displayName?: string | null, id: string };

export type ResourceName_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string };

export type ResourceName_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string };

export type ResourceName_FileAsset_Fragment = { __typename?: 'FileAsset', id: string };

export type ResourceName_FolderAsset_Fragment = { __typename?: 'FolderAsset', name: string, id: string };

export type ResourceName_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string };

export type ResourceName_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string };

export type ResourceName_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string };

export type ResourceName_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string };

export type ResourceName_Project_Fragment = { __typename?: 'Project', name: string, id: string };

export type ResourceName_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string };

export type ResourceName_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string };

export type ResourceName_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string };

export type ResourceName_Workspace_Fragment = { __typename?: 'Workspace', name: string, id: string };

export type ResourceNameFragment = ResourceName_Account_Fragment | ResourceName_AudioAsset_Fragment | ResourceName_DocumentAsset_Fragment | ResourceName_FileAsset_Fragment | ResourceName_FolderAsset_Fragment | ResourceName_ImageAsset_Fragment | ResourceName_InteractiveAsset_Fragment | ResourceName_InteractiveLiveAsset_Fragment | ResourceName_ModelAsset_Fragment | ResourceName_Project_Fragment | ResourceName_UnsupportedAsset_Fragment | ResourceName_VersionStackAsset_Fragment | ResourceName_VideoAsset_Fragment | ResourceName_Workspace_Fragment;

export type ResourceMembershipFragment = { __typename?: 'Membership', id: string, type: string, role?: { __typename?: 'Role', id: string, name: string } | null, accountUser?: { __typename?: 'AccountUser', id: string, avatarColor?: Types.AvatarColor | null, displayName?: string | null, email?: string | null, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, userId?: string | null, profileImageUrl?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', id: string, emoji?: string | null, name?: string | null } | null, userGroup?: { __typename?: 'AdobeManagedUserGroup', id: string, emoji?: string | null, name?: string | null } | { __typename?: 'FrameManagedUserGroup', id: string, emoji?: string | null, name?: string | null } | { __typename?: 'WorkfrontManagedUserGroup', id: string, emoji?: string | null, name?: string | null } | null, otherMemberships?: { __typename?: 'MembershipConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, accountUserGroup?: { __typename?: 'AccountUserGroup', accountId: string, emoji?: string | null, id: string, name?: string | null } | null, userGroup?: { __typename?: 'AdobeManagedUserGroup', emoji?: string | null, id: string, name?: string | null, account?: { __typename?: 'Account', id: string } | null } | { __typename?: 'FrameManagedUserGroup', emoji?: string | null, id: string, name?: string | null, account?: { __typename?: 'Account', id: string } | null } | { __typename?: 'WorkfrontManagedUserGroup', emoji?: string | null, id: string, name?: string | null, account?: { __typename?: 'Account', id: string } | null } | null, grantingResource?: { __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum } | null }> } | null };

export type ResourcesGrantingAccess_Account_Fragment = { __typename?: 'Account', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_Project_Fragment = { __typename?: 'Project', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccess_Workspace_Fragment = { __typename?: 'Workspace', id: string, accessGrantingResources?: { __typename?: 'AccessGrantingResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum, memberCount: number, permissions?: { __typename?: 'AccessGrantingResourcePermissions', canEditUserPermissions: boolean } | null }> } | null };

export type ResourcesGrantingAccessFragment = ResourcesGrantingAccess_Account_Fragment | ResourcesGrantingAccess_AudioAsset_Fragment | ResourcesGrantingAccess_DocumentAsset_Fragment | ResourcesGrantingAccess_FileAsset_Fragment | ResourcesGrantingAccess_FolderAsset_Fragment | ResourcesGrantingAccess_ImageAsset_Fragment | ResourcesGrantingAccess_InteractiveAsset_Fragment | ResourcesGrantingAccess_InteractiveLiveAsset_Fragment | ResourcesGrantingAccess_ModelAsset_Fragment | ResourcesGrantingAccess_Project_Fragment | ResourcesGrantingAccess_UnsupportedAsset_Fragment | ResourcesGrantingAccess_VersionStackAsset_Fragment | ResourcesGrantingAccess_VideoAsset_Fragment | ResourcesGrantingAccess_Workspace_Fragment;

export type ResourceGrantingAccessFragment = { __typename?: 'Membership', id: string, grantingResource?: { __typename?: 'AccessGrantingResource', id: string, name?: string | null, resourceType: Types.ResourceTypeEnum } | null };

export const ResourceName = /*#__PURE__*/ gql`
    fragment ResourceName on Resource {
  id
  ... on Project {
    name
  }
  ... on Workspace {
    name
  }
  ... on Account {
    displayName
  }
  ... on FolderAsset {
    name
  }
}
    ` as unknown as DocumentNode<ResourceNameFragment, unknown>;
export const ResourceGrantingAccess = /*#__PURE__*/ gql`
    fragment ResourceGrantingAccess on Membership {
  id
  grantingResource {
    id
    name
    resourceType
  }
}
    ` as unknown as DocumentNode<ResourceGrantingAccessFragment, unknown>;
export const ResourceMembership = /*#__PURE__*/ gql`
    fragment ResourceMembership on Membership {
  id
  role {
    id
    name(locale: $locale)
  }
  type
  accountUser {
    id
    avatarColor
    displayName @client
    email
    inviteEmailAddress
    isPending
    name
    userId
    profileImageUrl
    licenseType
  }
  accountUserGroup {
    id
    emoji
    name
  }
  userGroup {
    id
    emoji
    name
  }
  otherMemberships(page: {first: 1}) {
    nodes {
      ...ResourceGrantingAccess
      id
      accountUserGroup {
        accountId
        emoji
        id
        name
      }
      userGroup {
        account {
          id
        }
        emoji
        id
        name
      }
    }
    totalCount
  }
}
    ${ResourceGrantingAccess}` as unknown as DocumentNode<ResourceMembershipFragment, unknown>;
export const ResourcesGrantingAccess = /*#__PURE__*/ gql`
    fragment ResourcesGrantingAccess on Resource {
  id
  accessGrantingResources(page: $page) {
    nodes {
      id
      name
      resourceType
      memberCount
      permissions {
        canEditUserPermissions
      }
    }
    totalCount
  }
}
    ` as unknown as DocumentNode<ResourcesGrantingAccessFragment, unknown>;

        

        
export const useResourceNameFragment = (
  input: string | Omit<UseFragmentOptions<ResourceNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Resource' } };
    return input;
  })();

  return useFragment<ResourceNameFragment>({
    fragment: ResourceName,
    fragmentName: 'ResourceName',
    ...options,
  });
};
  
        
        

        
export const useResourceMembershipFragment = (
  input: string | Omit<UseFragmentOptions<ResourceMembershipFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Membership' } };
    return input;
  })();

  return useFragment<ResourceMembershipFragment>({
    fragment: ResourceMembership,
    fragmentName: 'ResourceMembership',
    ...options,
  });
};
  
        
        

        
export const useResourcesGrantingAccessFragment = (
  input: string | Omit<UseFragmentOptions<ResourcesGrantingAccessFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Resource' } };
    return input;
  })();

  return useFragment<ResourcesGrantingAccessFragment>({
    fragment: ResourcesGrantingAccess,
    fragmentName: 'ResourcesGrantingAccess',
    ...options,
  });
};
  
        
        

        
export const useResourceGrantingAccessFragment = (
  input: string | Omit<UseFragmentOptions<ResourceGrantingAccessFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Membership' } };
    return input;
  })();

  return useFragment<ResourceGrantingAccessFragment>({
    fragment: ResourceGrantingAccess,
    fragmentName: 'ResourceGrantingAccess',
    ...options,
  });
};
  
        